import styled from 'styled-components';
import { AppButton } from 'common/ui/elements/AppButton';

interface PaymentButtonsProps {
  onConfirmPickupOrder: () => void;
  isSubmitting?: boolean;
}

export const PaymentButtons = ({ onConfirmPickupOrder, isSubmitting }: PaymentButtonsProps) => (
  <Wrapper className="widget">
    <AppButton label="Terminer la commande" action={onConfirmPickupOrder} disabled={isSubmitting} />
  </Wrapper>
);

/*
 * PayPal — ready when client provides credentials. Re-enable and remove pickup-only flow above.
 *
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { PAYPAL_CLIENT_ID } from '../../../../configuration';
import { Cart } from '../../../domain/entities/Cart';
import { appCurrency } from '../../../../configuration/helpers/constants';
import { useNotificationContext } from '../../../../common/configuration/notificationContextProvider';

interface PaymentButtonsProps {
  stateCart: Cart;
  deliveryCost: number;
  setOrderResponse: Dispatch<SetStateAction<any>>;
}

export function PaymentButtons({ stateCart, deliveryCost, setOrderResponse }: PaymentButtonsProps) {
  const notifications = useNotificationContext();
  return (
    <Wrapper className="widget">
      <h4 className="widget-title">Mode de paiement</h4>
      <div className="paypal-fay-container">
        <PayPalScriptProvider options={{ 'client-id': PAYPAL_CLIENT_ID, currency: appCurrency.name, locale: 'fr_FR' }}>
          <PayPalButtons
            fundingSource="card"
            createOrder={(data, actions) =>
              actions.order.create({
                purchase_units: [{ amount: { value: (stateCart.total + deliveryCost).toFixed(2).toString() } }],
              })
            }
            onApprove={async (data, actions) => {
              const order = await actions?.order?.capture();
              setOrderResponse(order);
            }}
            onError={(err) => {
              notifications.setMessage({
                message: "Une erreur s'est produite lors du paiement, veuillez réessayer plus tard.",
                status: 'error',
              });
              console.error('An error occurred during payment', err);
            }}
          />
        </PayPalScriptProvider>
      </div>
    </Wrapper>
  );
}
*/

const Wrapper = styled.div``;
